export const LIST_LABEL    = 'LIST_LABEL';
export const CREATE_LABEL  = 'CREATE_LABEL';
export const LABEL_LOADING = 'LABEL_LOADING';
export const COUNT_LABEL_BY_STATUS = 'COUNT_LABEL_BY_STATUS';
export const DELETE_SOFT   = 'DELETE_SOFT';
export const DELETE_HARD   = 'DELETE_HARD';
export const UNASSIGN_LABEL = 'UNASSIGN_LABEL';
export const ASSIGN_LABEL = 'ASSIGN_LABEL';
export const BULK_UPDATE_LABEL_ITEMS = 'BULK_UPDATE_LABEL_ITEMS';
export const LIST_LABELS_BY_ITEM = 'LIST_LABELS_BY_ITEM';
export const LIST_LABEL_ASSIGN = 'LIST_LABEL_ASSIGN';
export const LABEL_ASSIGN_LOADING = 'LABEL_ASSIGN_LOADING';
